import { PermissionNames } from "../types/account.types"
import { RightElement, SettingsParentPage } from "./header.types"

export const NAVIGATION_ITEMS: any[] = [
  {
    route: '/',
    name: 'Home',
    mobile: false
  },
  {
    route: '/pages/about-us',
    name: 'About Us',
    submenu: [
      {
        route: '/pages/about-us',
        name: 'About Us',
      },
      {
        route: '/pages/community-impact',
        name: 'Community Impact',
      },
      {
        route: '/pages/what-sets-us-apart',
        name: 'Our Membership',
      },
      {
        route: '/pages/employee-wellness',
        name: 'Employee Wellness',
      }
    ]
  },
  {
    route: '/pages/how-it-works',
    name: 'How it Works',
    submenu: [
      {
        route: '/pages/how-it-works',
        name: 'How it Works',
      },
      {
        route: '/pages/delivery-areas',
        name: 'Delivery Area',
      },
      {
        route: '/pages/faq',
        name: 'FAQs',
      }
    ]
  },
  {
    route: '/pages/producers',
    name: 'Our Producers'
  },
  {
    route: '/shop',
    name: 'Shop'
  },
  {
    route: '/pages/blog',
    name: 'Blog'
  },
  {
    route: '/pages/contact-us',
    name: 'Contact Us'
  },
  {
    route: '/pages/gift-cards',
    name: 'Gift Cards'
  }
]

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'account_circle',
    name: 'Account settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals
      },
    ],
    permissionName: PermissionNames.settings
  },
  {
    icon: 'credit_card',
    name: 'Billing settings',
    children: [
      {
        route: '/settings/billing/payment-method',
        name: 'Payment Method',
        permissionName: PermissionNames.settingsPaymentMethod
      },
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory
      },
    ],
    permissionName: PermissionNames.settings
  },
]

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop
  },
  {
    id: 'toggleCardPreviewNav',
    tooltip: 'Cart',
    route: '',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true,
    shouldShowCartPreview: true
  },
]
